import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value"];
import InviteTeamIcon from '@atlaskit/icon/glyph/invite-team';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../../../messages';
import { FlexibleUiContext } from '../../../../../state/flexible-ui-context';
import ServerAction from '../action/server-action';
import UnfollowIcon from './unfollow-icon';
var FollowAction = function FollowAction(props) {
  var context = useContext(FlexibleUiContext);
  if (!context || !context.followAction) {
    return null;
  }
  var _context$followAction = context.followAction,
    value = _context$followAction.value,
    data = _objectWithoutProperties(_context$followAction, _excluded);
  var message = value ? messages.follow : messages.unfollow;
  var icon = value ? /*#__PURE__*/React.createElement(InviteTeamIcon, {
    label: "Follow"
  }) : /*#__PURE__*/React.createElement(UnfollowIcon, {
    label: "Unfollow"
  });
  return /*#__PURE__*/React.createElement(ServerAction, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, message),
    icon: icon,
    testId: "smart-action-follow-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, message)
  }, data, props));
};
export default FollowAction;